import React from 'react';
import PropTypes from 'prop-types';

/**
 * NonInteractiveDropdownTrigger
 * Renders visual dropdown content as non-interactive, and overlays a button to handle clicks/keyboard.
 * This prevents underlying dropdowns from opening while keeping a11y and controlled open behavior.
 */
export default function NonInteractiveDropdownTrigger({
  id,
  testId,
  wrapperClassName = '',
  ariaLabel = 'Open selection',
  onOpen,
  children
}) {
  return (
    <div
      id={id}
      data-testid={testId}
      className={`relative inline-block self-start ${wrapperClassName}`}
      onPointerDownCapture={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}>
      <div className='pointer-events-none' aria-hidden>
        {children}
      </div>
      <button
        type='button'
        aria-label={ariaLabel}
        className='absolute inset-0 z-10'
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={onOpen}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onOpen?.();
          }
        }}
        data-testid={testId ? `${testId}-overlay` : undefined}
      />
    </div>
  );
}

NonInteractiveDropdownTrigger.propTypes = {
  id: PropTypes.string,
  testId: PropTypes.string,
  wrapperClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
  onOpen: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
